import { SortDirection } from '@tanstack/react-table';
import React from 'react';

import { Icon } from '~/packages/common-frontend/components/icons';

type SortIconProps = { columnCanSort: boolean; sorted: false | SortDirection };
export const SortIcon = ({ columnCanSort, sorted }: SortIconProps) => {
  if (!columnCanSort) return null;
  if (sorted === 'asc') return <Icon icon="sort-up" />;
  if (sorted === 'desc') return <Icon icon="sort-down" />;
  return <Icon icon="sort" />;
};
